import React from "react";
import "./styles.css";
import findIcon from "../../../Assets/Icons/Iconsearch.png";
import leftArrow from "../../../Assets/Icons/left-arrow.svg";
import Table from "../Table";

const SharingHistory = ({ handleSharingHistory }) => {
  let columns = [
    {
      id: 1,
      label: "Report",
      subText: "(Report Name)",
      isIcon: false,
      iconsList: [],
      sortingRequired: true,
    },
    {
      id: 2,
      label: "Date",
      subText: "(of Shared)",
      isIcon: false,
      iconsList: [],
      sortingRequired: true,
    },
    {
      id: 3,
      label: "Recipient",
      subText: "(Name of Doctor)",
      isIcon: false,
      iconsList: [],
      sortingRequired: true,
    },
  ];

  const rows = [
    {
      _id: 5,
      disabled: false,
      tableData: [
        {
          id: 1,
          text: "MRI Report",
        },
        {
          id: 2,
          text: "13/04/2023",
        },
        {
          id: 3,
          text: "Dr. Shikha Singh",
        },
      ],
    },
    {
      _id: 6,
      disabled: false,
      tableData: [
        {
          id: 1,
          text: "MRI Report",
        },
        {
          id: 2,
          text: "13/04/2023",
        },
        {
          id: 3,
          text: "Dr. Shikha Singh",
        },
      ],
    },
    {
      _id: 7,
      disabled: false,
      tableData: [
        {
          id: 1,
          text: "MRI Report",
        },
        {
          id: 2,
          text: "13/04/2023",
        },
        {
          id: 3,
          text: "Dr. Shikha Singh",
        },
      ],
    },
    {
      _id: 8,
      disabled: false,
      tableData: [
        {
          id: 1,
          text: "MRI Report",
        },
        {
          id: 2,
          text: "13/04/2023",
        },
        {
          id: 3,
          text: "Dr. Shikha Singh",
        },
      ],
    },
    {
      _id: 9,
      disabled: false,
      tableData: [
        {
          id: 1,
          text: "MRI Report",
        },
        {
          id: 2,
          text: "13/04/2023",
        },
        {
          id: 3,
          text: "Dr. Shikha Singh",
        },
      ],
    },
    {
      _id: 10,
      disabled: false,
      tableData: [
        {
          id: 1,
          text: "MRI Report",
        },
        {
          id: 2,
          text: "13/04/2023",
        },
        {
          id: 3,
          text: "Dr. Shikha Singh",
        },
      ],
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <div className="shared-reports">
        <h3 style={{ fontWeight: 500 }}>Shared Reports</h3>
        <div className="filter-back">
          <div className="share-search">
            <input
              type="text"
              placeholder="Search"
              style={{
                border: "none",
                backgroundColor: "transparent",
                outline: "none",
              }}
            />
            <img
              src={findIcon}
              alt="search"
              style={{ height: "15px", width: "15px" }}
            />
          </div>
          <button
            className="sharehistory-back"
            onClick={() => handleSharingHistory()}
          >
            <img
              src={leftArrow}
              alt="arrow"
              style={{ height: "15px", width: "15px" }}
            />
            Back
          </button>
        </div>
      </div>

      <div style={{ marginTop: "15px", width: "100%" }}>
        <Table columnList={columns} rowList={rows} view="expanded" />
      </div>
    </div>
  );
};

export default SharingHistory;
